import { combineReducers } from "redux";
import { FETCH_RECORDING_NOTES_BEGIN, FETCH_RECORDING_NOTES_FAILURE, FETCH_RECORDING_NOTES_SUCCESS } from "../../actions/notes";
function initialize(state = false, action) {
    switch (action.type) {
        case FETCH_RECORDING_NOTES_SUCCESS:
        case FETCH_RECORDING_NOTES_FAILURE:
            return true;
        default:
            return state;
    }
}
function loading(state = 0, action) {
    switch (action.type) {
        case FETCH_RECORDING_NOTES_BEGIN:
            return state + 1;
        case FETCH_RECORDING_NOTES_SUCCESS:
            return state - 1;
        case FETCH_RECORDING_NOTES_FAILURE:
            return state - 1;
        default:
            return state;
    }
}
// @deprecated
export function key(state = "notes", action) {
    switch (action.type) {
        default:
            return state;
    }
}
export default combineReducers({
    key,
    initialize,
    loading
});
